const RiskLevel = [
    {id: "0", value: "高風險"},    
    {id: "1", value: "中風險"},
    {id: "2", value: "低風險"},    
  ];  
  
  export default RiskLevel  